import { render, staticRenderFns } from "./PrecoDinamicoList.vue?vue&type=template&id=1bbdf00c"
import script from "./PrecoDinamicoList.vue?vue&type=script&lang=js"
export * from "./PrecoDinamicoList.vue?vue&type=script&lang=js"
import style0 from "./PrecoDinamicoList.vue?vue&type=style&index=0&id=1bbdf00c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports